import StressReplayPanel from "@/components/risk/StressReplayPanel";
export default function PStress() { return <StressReplayPanel range="P" />; }
